"use client";

import { Builder, BuilderComponent } from "@builder.io/react";
import { BuilderContent } from "@builder.io/sdk";
import "@builder.io/widgets/dist/lib/builder-widgets-async";
import { notFound } from "next/navigation";

interface BuilderPageProps {
  content: BuilderContent | undefined | null;
  model: string;
}

export default function RenderBuilderContent({ content, model }: BuilderPageProps) {
  return (
    <>
      {content || Builder.isPreviewing || Builder.isEditing ? (
        <BuilderComponent content={content ? content : undefined} model={model} />
      ) : (
        notFound()
      )}
    </>
  );
}
